import { gql } from '@apollo/client';

/**
 * Self-service view of a service provider's own profile. Fields are listed
 * explicitly rather than pulled from the serviceProvider fragment so that
 * admin-only values (funder, programmes, geographies) never reach the client.
 */
export const GET_MY_SERVICE_PROVIDER_PROFILE = gql`
  query GetMyServiceProviderProfile($id: ID!) {
    serviceProvider: getServiceProvider(id: $id) {
      id
      name
      registrationNumber
      type
      legalStructure
      roles
      email
      contactNumber
      website
      logo
      physicalAddress
      description

      firstContactPerson
      designation
      firstContactPersonEmail
      firstContactPersonNumber

      secondContactPerson
      title
      secondContactPersonEmail
      secondContactPersonNumber

      orgLeader
      orgLeaderDesignation
      orgLeaderNumber
      orgLeaderPersonEmail

      organisationUsersAddOns {
        id
        name
      }
      organisationUsersPlan {
        id
        name
      }
    }
  }
`;
